"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _useFormElementValidation = _interopRequireDefault(require("../../hooks/useFormElementValidation"));
var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));
var _useLabel2 = _interopRequireDefault(require("../../hooks/useLabel"));
var _excluded = ["id", "name", "values", "label", "helper", "min", "max", "displayEdgeValues", "displayTooltip", "readOnly", "disabled", "required", "onChange", "onError", "className", "labelAria"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * The Input component allows an user to enter data into the application.
 */
var MultiRangeSlider = function MultiRangeSlider(props) {
  var controlledId = props.id,
    name = props.name,
    controlledValues = props.values,
    initialLabel = props.label,
    helper = props.helper,
    min = props.min,
    max = props.max,
    displayEdgeValues = props.displayEdgeValues,
    displayTooltip = props.displayTooltip,
    readOnly = props.readOnly,
    disabled = props.disabled,
    required = props.required,
    onChange = props.onChange,
    onError = props.onError,
    className = props.className,
    labelAria = props.labelAria,
    attributes = _objectWithoutPropertiesLoose(props, _excluded);
  var multiRangeRef = _react.default.useRef(null);
  var id = _react.default.useRef((0, _useRandomId.default)(controlledId)).current;
  var _React$useState = _react.default.useState(controlledValues),
    values = _React$useState[0],
    setValues = _React$useState[1];
  var _React$useState2 = _react.default.useState(controlledValues[0]),
    minValue = _React$useState2[0],
    setMinValue = _React$useState2[1];
  var _React$useState3 = _react.default.useState(controlledValues[1]),
    maxValue = _React$useState3[0],
    setMaxValue = _React$useState3[1];
  var minValueRef = _react.default.useRef(controlledValues[0]);
  var maxValueRef = _react.default.useRef(controlledValues[1]);
  var minTooltipRef = _react.default.useRef(null);
  var maxTooltipRef = _react.default.useRef(null);
  var _React$useState4 = _react.default.useState(false),
    error = _React$useState4[0],
    setError = _React$useState4[1];
  var _useFormElementValida = (0, _useFormElementValidation.default)(values, {
      required: required
    }),
    newValues = _useFormElementValida[0],
    errors = _useFormElementValida[1];
  var _useLabel = (0, _useLabel2.default)(initialLabel, _extends({}, props, {
      id: id,
      value: newValues
    })),
    label = _useLabel.label;
  _react.default.useEffect(function () {
    return setValues(controlledValues || []);
  }, [controlledValues]);
  _react.default.useEffect(function () {
    return setValues(newValues);
  }, [newValues]);
  _react.default.useEffect(function () {
    setError(errors.length > 0);
    if (typeof onError === 'function') {
      onError({
        name: 'MultiRange',
        errors: errors.length ? errors : []
      });
    }
  }, [errors, onError]);
  var getPercent = (0, _react.useCallback)(function (value) {
    return Math.round((value - min) / (max - min) * 100);
  }, [min, max]);

  // Set width of the range from the left side
  (0, _react.useEffect)(function () {
    var minPercent = getPercent(minValue);
    var maxPercent = getPercent(maxValueRef.current);
    // const newPosition = -3 - minPercent * 0.3;

    if (multiRangeRef.current) {
      multiRangeRef.current.style.left = minPercent + "%";
      multiRangeRef.current.style.width = maxPercent - minPercent + "%";
    }
    if (minTooltipRef.current) {
      // minTooltipRef.current.style.transform = 'translateX(-50%)';
      minTooltipRef.current.style.left = minPercent + "%";
      // minTooltipRef.current.style.left = `calc(${minPercent}% + ${newPosition}px)`;
    }
  }, [minValue, getPercent]);

  // Set width of the range from the right side
  (0, _react.useEffect)(function () {
    var minPercent = getPercent(minValueRef.current);
    var maxPercent = getPercent(maxValue);
    // const newPosition = -3 - maxPercent * 0.3;

    if (multiRangeRef.current) {
      multiRangeRef.current.style.width = maxPercent - minPercent + "%";
    }
    if (maxTooltipRef.current) {
      maxTooltipRef.current.style.transform = 'translateX(-50%)';
      maxTooltipRef.current.style.left = maxPercent + "%";
      // maxTooltipRef.current.style.left = `calc(${maxPercent}% + ${newPosition}px)`;
    }
  }, [maxValue, getPercent]);
  var handleChangeMin = function handleChangeMin(event) {
    var value = Math.min(Number(event.target.value), maxValue - 1);
    if (typeof onChange === 'function') {
      setMinValue(value);
      minValueRef.current = value;
    }
  };
  var handleChangeMax = function handleChangeMax(event) {
    var value = Math.max(Number(event.target.value), minValue + 1);
    if (typeof onChange === 'function') {
      setMaxValue(value);
      maxValueRef.current = value;
    }
  };
  var showTooltip = function showTooltip(ref) {
    if (ref.current) {
      ref.current.style.display = 'block';
    }
  };
  var hideTooltip = function hideTooltip(ref) {
    if (ref.current) {
      ref.current.style.display = 'block';
    }
  };
  var containerClasses = (0, _clsx.default)('uk-range-slider', (helper.length > 0 || error) && 'has-helper', error && 'has-error', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: containerClasses
  }, label, /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__container"
  }, displayEdgeValues && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__edge-value uk-range-slider__left-value"
  }, minValue), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__inputs"
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    type: "range",
    name: "min",
    min: min,
    max: max,
    value: minValue,
    className: "multi-range multi-range--left",
    "aria-valuemin": min,
    "aria-valuemax": maxValue,
    "aria-valuenow": minValue,
    "aria-labelledby": "label-" + id,
    "aria-label": "Minimum value",
    onChange: handleChangeMin,
    onMouseOver: function onMouseOver() {
      return showTooltip(minTooltipRef);
    },
    onMouseOut: function onMouseOut() {
      return hideTooltip(minTooltipRef);
    },
    onFocus: function onFocus() {
      return showTooltip(minTooltipRef);
    },
    onBlur: function onBlur() {
      return hideTooltip(minTooltipRef);
    }
  }, attributes)), displayTooltip && /*#__PURE__*/_react.default.createElement("div", {
    ref: minTooltipRef,
    className: "tooltip"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip- tooltip--left"
  }, minValue)), /*#__PURE__*/_react.default.createElement("input", _extends({
    type: "range",
    name: "max",
    min: min,
    max: max,
    value: maxValue,
    className: "multi-range multi-range--right",
    "aria-valuemax": max,
    "aria-valuenow": maxValue,
    "aria-labelledby": "label-" + id,
    "aria-label": "Maximum value",
    onChange: handleChangeMax,
    onMouseOver: function onMouseOver() {
      return showTooltip(maxTooltipRef);
    },
    onMouseOut: function onMouseOut() {
      return hideTooltip(maxTooltipRef);
    },
    onFocus: function onFocus() {
      return showTooltip(maxTooltipRef);
    },
    onBlur: function onBlur() {
      return hideTooltip(maxTooltipRef);
    }
  }, attributes)), displayTooltip && /*#__PURE__*/_react.default.createElement("div", {
    ref: maxTooltipRef,
    className: "tooltip tooltip--right"
  }, maxValue), /*#__PURE__*/_react.default.createElement("div", {
    className: "slider"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "slider__track"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "slider__range",
    ref: multiRangeRef
  }))), displayEdgeValues && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__edge-value uk-range-slider__right-value"
  }, maxValue)), (helper.length > 0 || error) && /*#__PURE__*/_react.default.createElement("small", {
    className: "helper"
  }, error || helper));
};
MultiRangeSlider.propTypes = {
  /**
   * ID of the RangeSlider (used to bind the label to the Input)
   * NB: the ID will be randomly generated if not set.
   */
  id: _propTypes.default.string,
  /**
   * Name of the RangeSlider (used instead of the ID when submitted)
   */
  name: _propTypes.default.string,
  /**
   * Default values of the RangeSlider
   * Set one or two handles depending of the size of the array
   */
  values: _propTypes.default.arrayOf(_propTypes.default.number),
  /**
   * Label of the RangeSlider
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  /**
   * Helper text, is replaced by a message in case of error
   */
  helper: _propTypes.default.string,
  /**
   * Minimum value of the RangeSlider
   */
  min: _propTypes.default.number,
  /**
   * Maximun value of the RangeSlider
   */
  max: _propTypes.default.number,
  /**
   * Display the minimum and maximum values on both sides of the RangeSlider
   */
  displayEdgeValues: _propTypes.default.bool,
  /**
   * Set the RangeSlider as read-only
   */
  readOnly: _propTypes.default.bool,
  /**
   * Set the RangeSlider as disabled
   */
  disabled: _propTypes.default.bool,
  /**
   * Form-validation: set the RangeSlider as required
   */
  required: _propTypes.default.bool,
  /**
   * Callback function onChange
   * Invoked AFTER new values had been set by the RangeSlider
   */
  onChange: _propTypes.default.func,
  /**
   * Callback function onError
   */
  onError: _propTypes.default.func,
  /**
   * Display current value when hover the thumb
   */
  displayTooltip: _propTypes.default.bool,
  /**
   * Provide text to labelAria only if props label is omitted.
   */
  labelAria: _propTypes.default.string
};
MultiRangeSlider.defaultProps = {
  helper: '',
  readOnly: false,
  disabled: false,
  required: false,
  name: 'single-range',
  min: 0,
  max: 100,
  values: [20, 80],
  displayEdgeValues: true,
  displayTooltip: true
};
var _default = exports.default = MultiRangeSlider;